/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/CreditCard',[
    './Logger',
    'plugins/moment-timezone.min'
], function (Logger, moment) {
        'use strict';

        function getCreditCardName(ccCode) {
            switch (ccCode) {
                case 'V':
                    return 'Visa';
                case 'A':
                    return 'American Express';
                case 'D':
                    return 'Discover';
                case 'M':
                    return 'MasterCard';
                default:
                    return null;
            }
        }

        function getCreditCardCode(ccname) {
            switch (ccname) {
                case 'visa':
                    return 'V';
                case 'american':
                    return 'A';
                case 'discover':
                    return 'D';
                case 'mastercard':
                    return 'M';
                default:
                    return null;
            }
        }

        function getCreditCardCssClass(ccCode) {
            switch (ccCode) {
                case 'V':
                    return 'payment-visa';
                case 'A':
                    return 'payment-americanexpress';
                case 'D':
                    return 'payment-discover';
                case 'M':
                    return 'payment-mastercard';
                default:
                    return null;
            }
        }

        function getMaskedCardNumber(ccNum, last4) {
            return '************' + last4;
        }

        function detectCreditCardType(ccnum) {
            if (ccnum && ccnum.length > 0) {
                var firstNumber = ccnum.charAt(0);

                if (firstNumber === '4') {
                    return 'V';
                } else if (firstNumber === '3') {
                    return 'A';
                } else if (firstNumber === '6') {
                    return 'D';
                } else if (firstNumber === '2' || firstNumber === '5') {
                    return 'M';
                }
            }
            return null;
        }

        function validateCvvCode(cardType, cvvCode) {
            var digits = 0;
            switch (getCreditCardName(cardType).toUpperCase()) {
                case 'MASTERCARD':
                case 'EUROCARD':
                case 'MASTERCARD/EUROCARD':
                case 'VISA':
                case 'DISCOVER':
                    digits = 3;
                    break;
                case 'AMEX':
                case 'AMERICANEXPRESS':
                case 'AMERICAN EXPRESS':
                    digits = 4;
                    break;
                default:
                    return false;
            }

            var regExp = new RegExp('[0-9]{' + digits + '}');
            return (cvvCode.length == digits && regExp.test(cvvCode));
        }

        function validateCCType(cctype, ccnum) {
            var fieldVal = true;
            ccnum = ccnum.replace(/\D/g, '');
            cctype = cctype.toLowerCase();

            var firstNumber = ccnum.charAt(0);

            if (firstNumber === '4') {
                fieldVal = cctype.indexOf('visa') >= 0;
            } else if (firstNumber === '3') {
                fieldVal = cctype.indexOf('american') >= 0;
            } else if (firstNumber === '6') {
                fieldVal = cctype.indexOf('discover') >= 0;
            } else if (firstNumber === '5' || firstNumber === '2') {
                fieldVal = cctype.indexOf('mastercard') >= 0;
            }
            return fieldVal;
        }

        function validateCCNum(ccnum) {
            var fieldVal = true;
            var iChkSum = 0;

            //break when masked number
            if (ccnum.length === 16 && ccnum.indexOf('***********') > -1) {
                return true;
            }

            ccnum = ccnum.replace(/\D/g, '');
            if (ccnum.length < 13) {
                return false;
            }
            var ccnumchk = [];
            var i;

            for (i = 0; i < ccnum.length; i++) {
                ccnumchk[ccnum.length - 1 - i] = ccnum.substring(i, i + 1);
            }

            for (i = 0; i < ccnum.length; i++) {
                if (i % 2 !== 0) {
                    ccnumchk[i] = ccnumchk[i] * 2;
                    if (ccnumchk[i] >= 10) {
                        ccnumchk[i] = ccnumchk[i] - 9;
                    }
                }
                ccnumchk[i]++;
                ccnumchk[i]--;
                iChkSum = iChkSum + ccnumchk[i].valueOf();
            }

            if (iChkSum % 10 !== 0) {
                fieldVal = false;
            }

            return fieldVal;
        }

        function validateExpirationDate(month, year) {
            var expirationMoment = moment(year + '-' + month + '-01');
            var currentMoment = moment().startOf('month');
            return expirationMoment.isSame(currentMoment) || expirationMoment.isAfter(currentMoment);
        }

        function getLast4(ccnum) {
            return ccnum.substr(ccnum.length - 4);
        }

        var CreditCard = {
            getCreditCardCode: getCreditCardCode,
            getCreditCardCssClass: getCreditCardCssClass,
            detectCreditCardType: detectCreditCardType,
            validateCvvCode: validateCvvCode,
            validateCCType: validateCCType,
            validateCCNum: validateCCNum,
            validateExpirationDate: validateExpirationDate,
            getLast4: getLast4,
            getCreditCardName: getCreditCardName,
            getMaskedCardNumber: getMaskedCardNumber
        };

        Logger.debug('CreditCard.js Loaded:', CreditCard);

        return CreditCard;
    });
